export const clipLengthLabel = (
  startTime: number,
  endTime: number,
  shortLabel: boolean
): string => {
  const seconds = endTime - startTime;
  const minutes = Math.floor(seconds / 60);
  if (shortLabel) return seconds > 60 ? `${minutes}m` : `${seconds}s`;

  if (seconds < 60) return `${seconds} second`;

  return `${minutes} minute`;
};

export const clipDefaultEndTime = (
  callDuration: number | null | undefined,
  clipStartTime: number
): number => {
  return callDuration && callDuration < 300
    ? callDuration
    : clipStartTime + 300;
};
